/* WristPop – Skripte der Produktseite main-product-frame
   Ausgelagert aus sections/main-product-frame.liquid, geladen mit defer.
   Die produktabhaengigen Daten stehen weiter inline in der Section
   und werden hier ueber window.kpd*Data gelesen. */

/* ===== Block 1 aus main-product-frame.liquid ===== */
function kpdOpenVideo(){
            var o=document.getElementById('kpd-video-overlay');
            o.style.display='flex';
            document.body.style.overflow='hidden';
            var v=document.getElementById('kpd-video-el');
            if(v){ try{ v.currentTime=0; v.play(); }catch(e){} }
          }
          function kpdCloseVideo(e){
            if(e && e.target && e.target.id !== 'kpd-video-overlay') return;
            var o=document.getElementById('kpd-video-overlay');
            var v=document.getElementById('kpd-video-el');
            if(v){ v.pause(); }
            o.style.display='none';
            document.body.style.overflow='';
          }

/* ===== Block 2 aus main-product-frame.liquid ===== */
(function(){
        var track = document.getElementById('kpd-guarantee-track');
        if(!track) return;
        var dots = track.parentNode.querySelectorAll('.kpd-gdot');
        track.addEventListener('scroll', function(){
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function(d,i){
            d.style.background = i === idx ? '#9A7B3C' : 'rgba(250,250,248,.25)';
          });
        }, { passive: true });
      })();

/* ===== Block 4 aus main-product-frame.liquid ===== */
var kpdLightboxImages = [];
var KPD_COLORS = {
  'Schwarz':'#1A1A1A','Weiß':'#FEFEFE','Hellrosa':'#F9A8C9',
  'Grün':'#22C55E','Hellgrün':'#86EFAC','Mitternachtsblau':'#1E3A5F',
  'Blau':'#3B82F6','Altrosa':'#F472B6','Hellblau':'#7EC8E3',
  'Gelb':'#F5C800','Rot':'#DC2626'
};

// Optionswert -> Alt-Text-Token: "3 Uhr" -> "3uhr", "Silber" -> "silber"
function kpdSlug(v) {
  return (v || '').toString().trim().toLowerCase()
    .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
    .replace(/[^a-z0-9]/g,'');
}

// Falls Shopify die Optionswerte uebersetzt (EN-Markt), auf die
// deutschen Alt-Text-Tokens zurueckmappen. Alt-Texte bleiben immer deutsch.
var KPD_EN_TO_DE = {
  'silver':'silber', 'black':'schwarz', 'white':'weiss',
  'lightpink':'hellrosa', 'green':'gruen', 'lightgreen':'hellgruen',
  'midnightblue':'mitternachtsblau', 'blue':'blau', 'darkblue':'dunkelblau', 'dustypink':'altrosa',
  'lightblue':'hellblau', 'yellow':'gelb', 'red':'rot'
};

function kpdToken(v) {
  var raw = (v || '').toString();
  var t = kpdSlug(raw);

  // Feste Farb-Uebersetzung (EN -> DE)
  if (KPD_EN_TO_DE[t]) return KPD_EN_TO_DE[t];

  // Kronenposition: ueber die Zahl erkennen, unabhaengig von der Uebersetzung.
  // "3 Uhr" / "3 o'clock" / "3 Hours" / "Crown at 3" -> alle "3uhr".
  // Farben enthalten keine Ziffern, daher ist jede Zahl eine Kronenposition.
  var num = raw.match(/(\d{1,2})/);
  if (num) return parseInt(num[1], 10) + 'uhr';

  return t;
}

// Optionstokens aus den rohen Werten bauen (dabei greift die
// EN-Rueckuebersetzung + Zahlenerkennung).
(function(){
  window.kpdAllOptionTokens = (window.kpdAllOptionValues || []).map(kpdToken);
})();

function kpdShowImagesForColor(colorName) {
  var container = document.getElementById('kpd-thumbs');
  if (!container) return;
  var thumbs = container.querySelectorAll('.kpd-thumb:not(.kpd-thumb-video)');
  var first = null;

  // Alle aktuell gewählten Optionswerte als Tokens
  var selected = kpdGetSelectedOptions();
  var wantedTokens = [];
  for (var k in selected) {
    if (selected.hasOwnProperty(k) && selected[k]) {
      var tok = kpdToken(selected[k]);
      if (tok && wantedTokens.indexOf(tok) === -1) wantedTokens.push(tok);
    }
  }

  thumbs.forEach(function(t) {
    var altRaw = (t.getAttribute('data-img-alt') || '').trim().toLowerCase();

    // Sprach-Filter
    if (window.kpdImgEn && (altRaw.indexOf('noen') !== -1 || altRaw.indexOf('de-only') !== -1 || altRaw.indexOf('deonly') !== -1)) {
      t.style.display = 'none'; t.classList.remove('kpd-thumb--active'); return;
    }
    if (!window.kpdImgEn && (altRaw.indexOf('enonly') !== -1 || altRaw.indexOf('en-only') !== -1)) {
      t.style.display = 'none'; t.classList.remove('kpd-thumb--active'); return;
    }
    var alt = altRaw.replace('noen','').replace('de-only','').replace('deonly','').replace('enonly','').replace('en-only','').trim();

    // Alt-Text in Tokens zerlegen: "silber-3uhr" -> ["silber","3uhr"]
    var imgTokens = alt.split(/[-_,\s|]+/).map(kpdSlug).filter(function(x){ return x !== ''; });

    // Ohne Alt-Text wird das Bild NICHT angezeigt.
    if (imgTokens.length === 0) {
      t.style.display = 'none'; t.classList.remove('kpd-thumb--active'); return;
    }

    // Universal-Bilder: nur bei explizitem Token (box/alle/universal).
    // Exakter Token-Vergleich, damit "metall" NICHT als "all" durchrutscht.
    var isUniversal = false;
    for (var u = 0; u < imgTokens.length; u++) {
      var ut = imgTokens[u];
      if (ut === 'box' || ut === 'verpackung' || ut === 'alle' || ut === 'all' || ut === 'universal') {
        isUniversal = true; break;
      }
    }

    var show;
    if (isUniversal) {
      show = true;
    } else {
      // Bild zeigen, wenn jeder seiner Options-Tokens zur Auswahl passt.
      // Tokens die kein Optionswert sind (z.B. "detail") werden ignoriert.
      show = true;
      for (var i = 0; i < imgTokens.length; i++) {
        var tk = imgTokens[i];
        var isOptionToken = window.kpdAllOptionTokens && window.kpdAllOptionTokens.indexOf(tk) !== -1;
        if (isOptionToken && wantedTokens.indexOf(tk) === -1) { show = false; break; }
      }
    }

    t.style.display = show ? 'block' : 'none';
    t.classList.remove('kpd-thumb--active');
    if (show && !isUniversal && !first) first = t;
  });

  // Fallback: falls nur Universal-Bilder sichtbar sind, nimm das erste sichtbare
  if (!first) {
    var firstVisible = null;
    thumbs.forEach(function(t){ if (t.style.display !== 'none' && !firstVisible) firstVisible = t; });
    first = firstVisible;
  }

  if (first) {
    first.classList.add('kpd-thumb--active');
    var img = document.getElementById('kpd-featured-img');
    var src = first.getAttribute('data-img-src');
    if (img && src && img.getAttribute('src') !== src) {
      // Smooth crossfade
      img.style.transition = 'opacity 0.15s ease, transform 0.15s ease';
      img.style.opacity = '0';
      img.style.transform = 'scale(0.96)';
      setTimeout(function() {
        img.setAttribute('src', src);
        img.onload = function() {
          img.style.opacity = '1';
          img.style.transform = 'scale(1)';
        };
        if (img.complete) {
          img.style.opacity = '1';
          img.style.transform = 'scale(1)';
        }
      }, 120);
    }
  }

  // Mobile-Swipe-Karussell aus den sichtbaren Bildern neu aufbauen
  kpdBuildMobileSlides(thumbs);
}

function kpdBuildMobileSlides(thumbs) {
  var car = document.getElementById('kpd-mobile-carousel');
  if (!car) return;
  // Nur bauen wenn Mobile (Karussell sichtbar)
  if (window.getComputedStyle(car).display === 'none') return;

  car.innerHTML = '';
  var slides = [];
  kpdLightboxImages = [];
  thumbs.forEach(function(t, idx) {
    if (t.style.display === 'none') return;
    var src = t.getAttribute('data-img-src');
    if (!src) return;
    var slide = document.createElement('div');
    slide.className = 'kpd-mobile-slide';
    var im = document.createElement('img');
    im.src = src;
    // Erste Slide ist auf Mobil das LCP-Element -> sofort laden.
    if (idx === 0) { im.loading = 'eager'; im.setAttribute('fetchpriority','high'); }
    else { im.loading = 'lazy'; }
    im.alt = t.getAttribute('data-img-alt') || '';
    im.style.cursor = 'zoom-in';
    var imgIndex = kpdLightboxImages.length;
    kpdLightboxImages.push({ type: 'image', src: src });
    // Tap (kein Swipe) oeffnet die Lightbox beim richtigen Bild
    (function(idx){
      var sx = 0, sy = 0;
      slide.addEventListener('touchstart', function(e){
        if (e.touches && e.touches[0]) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
      }, {passive:true});
      slide.addEventListener('touchend', function(e){
        var tx = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : sx;
        var ty = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientY : sy;
        if (Math.abs(tx - sx) < 12 && Math.abs(ty - sy) < 12) {
          kpdOpenLightbox(idx);
        }
      }, {passive:true});
      slide.addEventListener('click', function(){ kpdOpenLightbox(idx); });
    })(imgIndex);
    slide.appendChild(im);
    car.appendChild(slide);
    slides.push(slide);
  });

  // Video als letzte Slide
  var vidEl = document.getElementById('kpd-featured-video');
  if (vidEl && vidEl.querySelector('source')) {
    var vsrc = vidEl.querySelector('source').getAttribute('src');
    var vtype = vidEl.querySelector('source').getAttribute('type') || 'video/mp4';
    var poster = vidEl.getAttribute('poster') || '';
    var vslide = document.createElement('div');
    vslide.className = 'kpd-mobile-slide';
    var v = document.createElement('video');
    v.controls = true; v.playsInline = true; v.preload = 'metadata';
    if (poster) v.poster = poster;
    var s = document.createElement('source');
    s.src = vsrc; s.type = vtype;
    v.appendChild(s);
    vslide.appendChild(v);
    car.appendChild(vslide);
    slides.push(vslide);
    // Video auch in der Lightbox verfuegbar machen (als letzte Slide)
    kpdLightboxImages.push({ type: 'video', src: vsrc, vtype: vtype, poster: poster });
  }

  // Dots
  var dotsId = 'kpd-carousel-dots';
  var dots = document.getElementById(dotsId);
  if (!dots) {
    dots = document.createElement('div');
    dots.className = 'kpd-carousel-dots';
    dots.id = dotsId;
    car.parentNode.insertBefore(dots, car.nextSibling);
  }
  dots.innerHTML = '';
  slides.forEach(function(_, i) {
    var d = document.createElement('div');
    d.className = 'kpd-carousel-dot' + (i === 0 ? ' active' : '');
    dots.appendChild(d);
  });

  // Dot-Update beim Scrollen + Badge nur auf Bild 1 zeigen
  car.onscroll = function() {
    var idx = Math.round(car.scrollLeft / car.clientWidth);
    var ds = dots.querySelectorAll('.kpd-carousel-dot');
    ds.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
    kpdSyncBadge(idx);
  };
  car.scrollLeft = 0;
  kpdSyncBadge(0);
}

// Badge ein-/ausblenden: nur auf dem ersten Bild sichtbar.
// Wird vom Mobile-Karussell (Wischen) und von kpdSetImage (Desktop-Thumbs) gerufen.
function kpdSyncBadge(idx) {
  var show = (idx === 0);
  ['.kpd-badge-mobile', '.kpd-main-image .kpd-badge'].forEach(function(sel){
    var el = document.querySelector(sel);
    if (!el) return;
    el.style.transition = 'opacity .2s ease';
    el.style.opacity = show ? '1' : '0';
    el.style.pointerEvents = show ? '' : 'none';
  });
}

function kpdOpenLightbox(startIndex) {
  var imgs = kpdLightboxImages || [];
  if (!imgs.length) return;
  if (typeof startIndex !== 'number') startIndex = 0;

  var lb = document.getElementById('kpd-lightbox');
  if (!lb) {
    lb = document.createElement('div');
    lb.id = 'kpd-lightbox';
    lb.className = 'kpd-lightbox';
    lb.innerHTML =
      '<button class="kpd-lightbox-close" aria-label="Schließen">&times;</button>' +
      '<div class="kpd-lightbox-track" id="kpd-lightbox-track"></div>' +
      '<div class="kpd-lightbox-dots" id="kpd-lightbox-dots"></div>';
    document.body.appendChild(lb);
    lb.querySelector('.kpd-lightbox-close').addEventListener('click', kpdCloseLightbox);
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') kpdCloseLightbox();
    });
  }

  var track = lb.querySelector('#kpd-lightbox-track');
  var dots = lb.querySelector('#kpd-lightbox-dots');
  track.innerHTML = '';
  dots.innerHTML = '';

  imgs.forEach(function(item, i){
    var cell = document.createElement('div');
    cell.className = 'kpd-lightbox-cell';
    if (item.type === 'video') {
      var v = document.createElement('video');
      v.className = 'kpd-lightbox-video';
      v.controls = true; v.playsInline = true; v.preload = 'metadata';
      if (item.poster) v.poster = item.poster;
      var s = document.createElement('source');
      s.src = item.src; s.type = item.vtype || 'video/mp4';
      v.appendChild(s);
      cell.appendChild(v);
    } else {
      var im = document.createElement('img');
      im.src = item.src;
      im.className = 'kpd-lightbox-img';
      im.alt = '';
      cell.appendChild(im);
    }
    track.appendChild(cell);

    var d = document.createElement('div');
    d.className = 'kpd-lightbox-dot' + (i === startIndex ? ' active' : '');
    dots.appendChild(d);
  });

  // Tap auf Hintergrund (nicht auf Bild) schliesst
  track.onclick = function(e){
    if (e.target === track || e.target.classList.contains('kpd-lightbox-cell')) kpdCloseLightbox();
  };

  // Dot-Update beim Scrollen
  track.onscroll = function(){
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    var ds = dots.querySelectorAll('.kpd-lightbox-dot');
    ds.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
  };

  lb.style.display = 'flex';
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';

  // Zum angetippten Bild springen (nach Layout)
  requestAnimationFrame(function(){
    track.scrollLeft = startIndex * track.clientWidth;
  });
}

function kpdCloseLightbox() {
  var lb = document.getElementById('kpd-lightbox');
  if (!lb) return;
  lb.classList.remove('open');
  lb.style.display = 'none';
  document.body.style.overflow = '';
}

function kpdSelectOption(btn) {
  var optionName = btn.getAttribute('data-option-name');
  var optionValue = btn.getAttribute('data-option-value');

  // Update button styles
  var container = btn.parentElement;
  container.querySelectorAll('.kpd-option-btn').forEach(function(b) {
    b.classList.remove('kpd-option-btn--active');
    b.style.borderColor = '#E4E0D8';
    b.style.background = '#FFFFFF';
    b.style.color = '#2D2D2D';
  });
  btn.classList.add('kpd-option-btn--active');
  btn.style.borderColor = '#2D2D2D';
  btn.style.background = '#2D2D2D';
  btn.style.color = '#FFFFFF';

  // Update label
  var optionIndex = btn.getAttribute('data-option-index');
  var label = document.getElementById('kpd-selected-option-' + optionIndex);
  if (label) label.textContent = optionValue;

  // Find matching variant
  kpdUpdateVariant();

  // Bilder neu filtern (z.B. Kronenposition 3 Uhr / 12 Uhr)
  var activeColor = document.querySelector('.kpd-color-btn--active');
  kpdShowImagesForColor(activeColor ? activeColor.getAttribute('data-value') : null);
}

function kpdGetSelectedOptions() {
  var options = {};
  document.querySelectorAll('.kpd-color-btn--active').forEach(function(b) {
    var name = b.getAttribute('data-option-name') || 'Farbe';
    options[name] = b.getAttribute('data-value');
  });
  document.querySelectorAll('.kpd-option-btn--active').forEach(function(b) {
    options[b.getAttribute('data-option-name')] = b.getAttribute('data-option-value');
  });
  return options;
}

function kpdUpdateVariant() {
  var selected = kpdGetSelectedOptions();
  var variants = window.kpdVariantsData;
  var optionNames = window.kpdOptionNames;
  // Korrekt formatierte Preise pro Variante (Shopify money-Filter -> richtige Waehrung)
  var kpdPriceMap = window.kpdPriceMapData;

  // Auswahl in der Reihenfolge der Produktoptionen aufbauen
  var wanted = [];
  for (var n = 0; n < optionNames.length; n++) {
    wanted.push(selected[optionNames[n]] || null);
  }

  // EXAKTE Variante suchen: alle gewaehlten Optionen muessen passen
  var exact = null;
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var vOpts = [v.option1, v.option2, v.option3];
    var match = true;
    for (var j = 0; j < wanted.length; j++) {
      if (wanted[j] !== null && vOpts[j] !== wanted[j]) { match = false; break; }
    }
    if (match) { exact = v; break; }
  }

  var atc = document.getElementById('kpd-main-atc');
  var vidInput = document.getElementById('kpd-variant-id');
  var priceEl = document.getElementById('kpd-price');

  // Kombination existiert nicht ODER ist ausverkauft -> Button sperren
  if (!exact || !exact.available) {
    if (vidInput && exact) vidInput.value = exact.id;
    if (atc) {
      atc.disabled = true;
      atc.style.background = '#B8B6AE';
      atc.style.cursor = 'not-allowed';
      atc.onmouseover = null; atc.onmouseout = null;
      atc.textContent = window.kpdIsIt ? 'Combinazione non disponibile' : window.kpdIsEn ? 'Combination unavailable' : 'Nicht verfügbar';
    }
    if (exact && priceEl) {
      priceEl.textContent = (kpdPriceMap[exact.id] || ((exact.price / 100).toFixed(2) + ' ' + (window.Shopify && Shopify.currency ? Shopify.currency.active : '')));
    }
    return;
  }

  // Gueltige, lieferbare Variante
  if (vidInput) vidInput.value = exact.id;
  if (priceEl) {
    priceEl.textContent = (kpdPriceMap[exact.id] || ((exact.price / 100).toFixed(2) + ' ' + (window.Shopify && Shopify.currency ? Shopify.currency.active : '')));
  }
  if (atc) {
    atc.disabled = false;
    atc.style.background = '#2D2D2D';
    atc.style.cursor = 'pointer';
    atc.onmouseover = function(){ this.style.background = '#9A7B3C'; };
    atc.onmouseout = function(){ this.style.background = '#2D2D2D'; };
    atc.textContent = window.kpdIsIt ? 'Aggiungi al carrello' : window.kpdIsEn ? 'Add to cart' : 'In den Warenkorb';
  }
}

function kpdSelectColor(btn) {
  document.querySelectorAll('.kpd-color-btn').forEach(function(b){ b.classList.remove('kpd-color-btn--active'); });
  btn.classList.add('kpd-color-btn--active');
  var value = btn.getAttribute('data-value');
  var displayLabel = btn.getAttribute('data-label') || value;
  var label = document.getElementById('kpd-selected-color');
  if (label) label.textContent = displayLabel;
  kpdShowImagesForColor(value);
  // Variante immer aus der vollständigen Optionskombination bestimmen
  kpdUpdateVariant();
}

function kpdShowVideo(thumb) {
  var img = document.getElementById('kpd-featured-img');
  var vid = document.getElementById('kpd-featured-video');
  if (!vid) return;
  if (typeof kpdSyncBadge === 'function') kpdSyncBadge(-1);
  document.querySelectorAll('.kpd-thumb').forEach(function(t){ t.classList.remove('kpd-thumb--active'); });
  if (thumb) thumb.classList.add('kpd-thumb--active');
  if (img) img.style.display = 'none';
  vid.style.display = 'block';
  try { vid.play(); } catch(e) {}
}

function kpdSetImage(src, thumb) {
  var vid = document.getElementById('kpd-featured-video');
  if (vid) { vid.pause(); vid.style.display = 'none'; }
  document.querySelectorAll('.kpd-thumb').forEach(function(t){ t.classList.remove('kpd-thumb--active'); });
  if (thumb) thumb.classList.add('kpd-thumb--active');
  // Badge nur beim ersten sichtbaren Thumb zeigen
  if (typeof kpdSyncBadge === 'function') {
    var vis = [];
    document.querySelectorAll('#kpd-thumbs .kpd-thumb').forEach(function(t){
      if (t.style.display !== 'none') vis.push(t);
    });
    kpdSyncBadge(thumb ? vis.indexOf(thumb) : 0);
  }
  var img = document.getElementById('kpd-featured-img');
  if (img) img.style.display = '';
  if (img && src) {
    img.style.opacity = '0';
    img.style.transform = 'scale(0.97)';
    setTimeout(function(){
      img.setAttribute('src', src);
      img.onload = function(){
        img.style.opacity = '1';
        img.style.transform = 'scale(1)';
      };
      // Fallback if already cached
      if (img.complete) {
        img.style.opacity = '1';
        img.style.transform = 'scale(1)';
      }
    }, 100);
  }
}

function kpdQty(delta) {
  var input = document.getElementById('kpd-qty');
  var val = parseInt(input.value) + delta;
  if (val < 1) val = 1;
  input.value = val;
}


document.addEventListener('DOMContentLoaded', function() {
  var firstBtn = document.querySelector('.kpd-color-btn--active');
  if (firstBtn) {
    kpdShowImagesForColor(firstBtn.getAttribute('data-value'));
    var label = document.getElementById('kpd-selected-color');
    if (label) label.textContent = firstBtn.getAttribute('data-label') || firstBtn.getAttribute('data-value');
  }
  // Button-Zustand initial pruefen (falls Startkombination nicht existiert)
  if (typeof kpdUpdateVariant === 'function') kpdUpdateVariant();
  /* --- original else-Zweig unten unveraendert --- */
  if (!firstBtn) {
    document.querySelectorAll('.kpd-thumb').forEach(function(t){ t.style.display='block'; });
    var first = document.querySelector('.kpd-thumb');
    if (first) { first.classList.add('kpd-thumb--active'); }
    // Karussell aus allen Thumbs bauen
    var allThumbs = document.querySelectorAll('#kpd-thumbs .kpd-thumb:not(.kpd-thumb-video)');
    if (allThumbs.length) kpdBuildMobileSlides(allThumbs);
  }

  // Beim Wechsel Desktop <-> Mobile Karussell neu aufbauen.
  //
  // WICHTIG: Nur bei echtem Breakpoint-Wechsel neu bauen.
  // Mobile Browser feuern 'resize' auch beim Ein-/Ausblenden der
  // Adressleiste waehrend des Scrollens. Ein Neuaufbau setzt das
  // Karussell auf Bild 1 zurueck -> Bild "springt" beim Scrollen.
  var kpdResizeTimer;
  var kpdWasMobile = window.innerWidth <= 749;
  window.addEventListener('resize', function() {
    var isMobile = window.innerWidth <= 749;
    if (isMobile === kpdWasMobile) return;   // nur Hoehe geaendert -> ignorieren
    kpdWasMobile = isMobile;
    clearTimeout(kpdResizeTimer);
    kpdResizeTimer = setTimeout(function() {
      var active = document.querySelector('.kpd-color-btn--active');
      var thumbs = document.querySelectorAll('#kpd-thumbs .kpd-thumb:not(.kpd-thumb-video)');
      if (active) {
        kpdShowImagesForColor(active.getAttribute('data-value'));
      } else if (thumbs.length) {
        kpdBuildMobileSlides(thumbs);
      }
    }, 200);
  });
});

/* ===== Block 5 aus main-product-frame.liquid ===== */
function kpdStickyAddToCart(btn) {
  var vidInput = document.getElementById('kpd-variant-id');
  if(!vidInput || !vidInput.value) {
    // Fallback: submit the form
    var form = document.getElementById('kpd-form');
    if(form) form.dispatchEvent(new Event('submit', {bubbles:true, cancelable:true}));
    return;
  }
  var orig = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: parseInt(vidInput.value), quantity: 1})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    btn.disabled = false;
    btn.textContent = orig;
    window.location.href = '/cart';
  })
  .catch(function(){
    btn.disabled = false;
    btn.textContent = orig;
  });
}

(function(){
  var el = document.getElementById('kpd-viewers');
  if(!el) return;

  // Start with random number between 9-17
  var current = Math.floor(Math.random() * 9) + 9;
  el.textContent = current;

  // Fluctuate randomly every 8-22 seconds - looks organic
  function update() {
    var change = Math.random();
    if(change < 0.45) {
      // Go up by 1-2
      current += Math.random() < 0.7 ? 1 : 2;
    } else if(change < 0.85) {
      // Go down by 1
      current = Math.max(7, current - 1);
    }
    // Keep in realistic range
    current = Math.min(21, Math.max(7, current));
    el.textContent = current;

    // Next update in 8-22 seconds
    var next = Math.floor(Math.random() * 14000) + 8000;
    setTimeout(update, next);
  }

  // First update after 10-20 seconds
  setTimeout(update, Math.floor(Math.random() * 10000) + 10000);
})();

/* ===== Block 6 aus main-product-frame.liquid ===== */
// ── EXIT INTENT POPUP ──
(function(){
  if(sessionStorage.getItem('kpd_exit_shown')) return;
  var popup = document.getElementById('kpd-exit-popup');
  if(!popup) return;

  function showPopup(){
    if(sessionStorage.getItem('kpd_exit_shown')) return;
    popup.style.display = 'flex';
    sessionStorage.setItem('kpd_exit_shown', '1');
  }

  // Desktop: Maus verlaesst das Fenster nach oben
  document.addEventListener('mouseleave', function(e){
    if(e.clientY <= 5) showPopup();
  });

  // Mobile: schnelles Hochscrollen nahe am Seitenanfang
  var lastScrollY = window.scrollY;
  var scrollTimer, ticking = false;
  window.addEventListener('scroll', function(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      ticking = false;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        var currentY = window.scrollY;
        if(lastScrollY - currentY > 200 && currentY < 100) showPopup();
        lastScrollY = currentY;
      }, 100);
    });
  }, { passive: true });

  // Fallback: nach 15 Sekunden
  setTimeout(showPopup, 15000);
})();

function kpdClosePopup(){
  var popup = document.getElementById('kpd-exit-popup');
  if(popup) popup.style.display = 'none';
  var tab = document.getElementById('kpd-reopen-tab');
  if(tab) tab.style.display = 'flex';
}

function kpdReopenPopup(){
  var popup = document.getElementById('kpd-exit-popup');
  if(popup) popup.style.display = 'flex';
  var tab = document.getElementById('kpd-reopen-tab');
  if(tab) tab.style.display = 'none';
}

// Tab faehrt beim ersten Scrollen nach links ein und BLEIBT dort.
// Oeffnen nur noch per Klick (kpdReopenPopup). Kein automatisches Ausfahren.
(function(){
  var ticking = false, isIn = false;
  window.addEventListener('scroll', function(){
    if (ticking || isIn) return;
    ticking = true;
    requestAnimationFrame(function(){
      ticking = false;
      var tab = document.getElementById('kpd-reopen-tab');
      if(!tab || tab.style.display === 'none') return;
      if(window.scrollY > 40){ tab.style.transform = 'translateX(-75%)'; isIn = true; }
    });
  }, { passive: true });

  // Beim Ueberfahren/Antippen kurz herausschauen, damit er anklickbar bleibt
  document.addEventListener('DOMContentLoaded', function(){
    var tab = document.getElementById('kpd-reopen-tab');
    if(!tab) return;
    tab.addEventListener('mouseenter', function(){ tab.style.transform = 'translateX(0)'; });
    tab.addEventListener('mouseleave', function(){ if(isIn) tab.style.transform = 'translateX(-75%)'; });
  });
})();

function kpdClaimDiscount(){
  var emailInput = document.getElementById('kpd-popup-email');
  var email = (emailInput.value || '').trim();
  if(!email || email.indexOf('@') === -1) {
    emailInput.style.borderColor = '#DC2626';
    return;
  }

  // HINWEIS: Shopifys Kundenformular verlangt einen CAPTCHA-Token, den ein
  // verstecktes Formular nicht liefern kann. Daher wird hier nichts an
  // Shopify gesendet. Falls Klaviyo geladen ist, geht die Adresse dorthin.
  if (window._learnq) {
    window._learnq.push(['identify', { '$email': email }]);
    window._learnq.push(['track', 'Newsletter Signup', { '$email': email }]);
  }

  document.getElementById('kpd-popup-success').style.display = 'block';
  emailInput.style.display = 'none';
  var claimBtn = document.querySelector('#kpd-exit-popup button[onclick="kpdClaimDiscount()"]');
  if (claimBtn) claimBtn.style.display = 'none';
  setTimeout(kpdClosePopup, 6000);
}

// ── COUNTDOWN TIMER ──
(function(){
  var timerEl = document.getElementById('kpd-timer');
  if(!timerEl) return;

  // Get or set expiry - resets every 24h per session
  var key = 'kpd_timer_expiry';
  var expiry = sessionStorage.getItem(key);
  if(!expiry || Date.now() > parseInt(expiry)) {
    // Random time between 45min and 8 hours to look organic
    var ms = (Math.floor(Math.random() * 7 * 60) + 45) * 60 * 1000;
    expiry = Date.now() + ms;
    sessionStorage.setItem(key, expiry);
  }

  function update(){
    var remaining = parseInt(expiry) - Date.now();
    if(remaining <= 0){
      timerEl.textContent = '00:00:00';
      return;
    }
    var h = Math.floor(remaining / 3600000);
    var m = Math.floor((remaining % 3600000) / 60000);
    var s = Math.floor((remaining % 60000) / 1000);
    timerEl.textContent =
      String(h).padStart(2,'0') + ':' +
      String(m).padStart(2,'0') + ':' +
      String(s).padStart(2,'0');
    setTimeout(update, 1000);
  }
  update();
})();

// ── STICKY BAR ──
(function(){
  var bar = document.getElementById('kpd-sticky-bar');
  var form = document.getElementById('kpd-form');
  if(!bar || !form) return;

  var img = document.getElementById('kpd-featured-img');
  var stickyImg = document.getElementById('kpd-sticky-img-el');
  var stickyPrice = document.getElementById('kpd-sticky-price');
  var priceEl = document.getElementById('kpd-price');
  var mainAtc = document.getElementById('kpd-main-atc');

  function syncContent(){
    if(img && stickyImg && img.src) stickyImg.src = img.src;
    if(priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
  }
  syncContent();

  // Bild/Preis nur bei echten Aenderungen nachziehen (statt Polling)
  if (window.MutationObserver) {
    var mo = new MutationObserver(syncContent);
    if (img) mo.observe(img, { attributes: true, attributeFilter: ['src'] });
    if (priceEl) mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  // Startzustand: versteckt (kommt aus dem CSS)
  function show(){ bar.classList.add('kpd-sticky-bar--visible'); }
  function hide(){ bar.classList.remove('kpd-sticky-bar--visible'); }

  // Leiste NUR zeigen, wenn der echte Warenkorb-Button nicht sichtbar ist.
  if (mainAtc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { hide(); } else { show(); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    io.observe(mainAtc);
  } else {
    // Fallback: ab 600px Scrolltiefe einblenden
    var onScroll = function(){
      if (window.scrollY > 600) { show(); } else { hide(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/* ===== Block 8 aus main-product-frame.liquid ===== */
(function(){
  // Klick auf Judge.me Sterne-Badge -> sanft zum Karussell scrollen
  document.addEventListener('click', function(e){
    var badge = e.target.closest('#kpd-badge-clickable');
    if(!badge) return;
    // Erst eigenes Karussell suchen, sonst App-Karussell (jdgm-carousel-wrapper)
    var carousel = document.getElementById('kpd-reviews-carousel')
                || document.querySelector('.jdgm-carousel-wrapper');
    if(carousel){
      e.preventDefault();
      carousel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
